<template>
    <div class="wasserstoff">
        <p>
            Knallgasprobe
            <br />
            Luftgemisch verbrennt explosionsartig
        </p>
    </div>
</template>

<script>
export default {
    name: 'wasserstoff',
};
</script>
